export default __webpack_public_path__ + "static/media/china-telecom.73f65903.png";